import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/element.js'
import moment from 'moment'

Vue.config.productionTip = false
Vue.prototype.$resource = "http://192.168.10.248:1111/"
Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('YYYY年MM月DD日 HH时mm分')
    }
})
Vue.filter('hideIdCart', function (value) {
    const maskChar = '*'
    if (!value || value.length !== 18) {
        return '\u00A0';
    }
    return value.replace(/^(.{3})(.*)(.{4})$/, `$1${maskChar.repeat(10)}$3`);
})
Vue.filter('hidePhone', function (value) {
    const maskChar = '*'
    if (!value || value.length !== 11) {
        return '\u00A0';
    }
    return value.replace(/^(.{3})(.*)(.{4})$/, `$1${maskChar.repeat(4)}$3`);
})
Vue.filter('isNull', function (value) {
    if (value == null) {
        return '\u00A0';
    }
    else {
        return value;
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
